// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import StyledDataGrid from "../../../components/StyledDataGrid";
// import Divider from "@mui/material/Divider";
// import Box from "@mui/material/Box";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useEffect, useMemo, useState, useCallback } from "react";
// import { Alert } from "@mui/material";
// import { fetchCollectionKitsPaged } from "../../../utils/api";

// import CurrentDateDisplay from "../../../components/CurrentDate";

// const CollectionKit = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const [newKitPopup, setNewKitPopup] = useState(false);
//     const [highlightId, setHighlightId] = useState(null);

//     const [rows, setRows] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [totalRowCount, setTotalRowCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({
//         page: 0,
//         pageSize: 10,
//     });

//     const todayStr = useMemo(
//         () =>
//             new Date().toLocaleDateString("en-US", {
//                 year: "numeric",
//                 month: "long",
//                 day: "numeric",
//             }),
//         []
//     );

//     const handleNewKit = () => {
//         navigate("/collection-kits/new-kit");
//     };

//     const columns = [
//         { field: "kit_number", headerName: "Kit Number", flex: 1 },
//         {
//             field: "Status",
//             headerName: "Collection Status",
//             flex: 1,
//             renderCell: (params) => {
//                 const status = params.value;

//                 // Default styling
//                 let color = "#757575";
//                 let bgColor = "#F5F5F5";

//                 // 🌟 Apply harmonious colors and background based on status
//                 if (status === "Available") {
//                     color = "#0288d1"; // Light Blue text
//                     bgColor = "#e1f5fe"; // Very soft blue background
//                 } else if (status === "Partial") {
//                     color = "#ed6c02"; // Orange text
//                     bgColor = "#fff3e0"; // Very soft orange background
//                 } else if (status === "Completed") {
//                     color = "#2e7d32"; // Green text
//                     bgColor = "#e8f5e9"; // Very soft green background
//                 }


//     const loadPagedKits = useCallback(async () => {
//         setLoading(true);
//         try {
//             const data = await fetchCollectionKitsPaged(paginationModel.page, paginationModel.pageSize);

//             if (data && Array.isArray(data.content)) {
//                 let formattedRows = data.content.map((kitStatus) => {
//                     // 🌟 Map backend status to user-friendly UI status
//                     let displayStatus = "Unknown";
//                     if (kitStatus.collectionStatus === "NOT_STARTED") displayStatus = "Available";
//                     else if (kitStatus.collectionStatus === "PARTIAL") displayStatus = "Partial";
//                     else if (kitStatus.collectionStatus === "COMPLETED") displayStatus = "Completed";

//                     return {
//                         id: kitStatus.kitId,
//                         kit_number: kitStatus.kitId || "N/A",
//                         Status: displayStatus,
//                         summary: kitStatus.summary
//                     };
//                 });

//                 // 🌟 Apply Default Sort Order: Available -> Partial -> Completed
//                 const statusSortWeight = {
//                     "Available": 1,
//                     "Partial": 2,
//                     "Completed": 3,
//                     "Unknown": 4
//                 };

//                 formattedRows.sort((a, b) => statusSortWeight[a.Status] - statusSortWeight[b.Status]);

//                 setRows(formattedRows);
//                 setTotalRowCount(data.totalElements || 0);
//             } else {
//                 console.error("Unexpected API response structure:", data);
//                 setRows([]);
//                 setTotalRowCount(0);
//             }
//         } catch (error) {
//             console.error("Error fetching collection kits:", error);
//             setRows([]);
//             setTotalRowCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [paginationModel.page, paginationModel.pageSize]);

//     useEffect(() => {
//         loadPagedKits();
//     }, [loadPagedKits]);

//     useEffect(() => {
//         let popupTimer;
//         let highlightTimer;

//         if (location?.state?.complete) {
//             setNewKitPopup(true);

//             if (location?.state?.kitId) {
//                 setHighlightId(String(location.state.kitId));
//                 highlightTimer = setTimeout(() => setHighlightId(null), 10000);
//             }

//             popupTimer = setTimeout(() => setNewKitPopup(false), 10000);

//             if (window?.history?.replaceState) {
//                 const { pathname, search, hash } = window.location;
//                 window.history.replaceState({}, "", pathname + search + hash);
//             }
//         }

//         return () => {
//             if (popupTimer) clearTimeout(popupTimer);
//             if (highlightTimer) clearTimeout(highlightTimer);
//         };
//     }, [location?.state?.complete, location?.state?.kitId]);

//     const getRowClassName = (params) => {
//         const rowIdStr = String(params.id ?? "");
//         const kitNumberStr = String(params.row?.kit_number ?? "");
//         return highlightId &&
//         (rowIdStr === highlightId || kitNumberStr === highlightId)
//             ? "newly-registered"
//             : "";
//     };


//             <Typography
//                 sx={{
//                     color: "#500000",
//                     fontSize: "44.97px",
//                     fontWeight: 600,
//                     fontFamily: "'Brand Fonts', sans-serif",
//                     mb: 1,
//                 }}
//             >
//                 Collection Kits
//             </Typography>

//             <Typography
//                 sx={{
//                     color: "#3E3E3E",
//                     fontSize: "26px",
//                     fontWeight: 500,
//                     fontFamily: "'Brand Fonts', sans-serif",
//                 }}
//             >
//                 Today's Date: <CurrentDateDisplay />
//             </Typography>

//             <Divider
//                 sx={{
//                     width: "100%",
//                     height: "1px",
//                     backgroundColor: "#EAEAEA",
//                     border: "none",
//                     my: 2,
//                 }}
//             />

//             <Typography
//                 sx={{
//                     fontSize: "18px",
//                     fontWeight: 600,
//                     fontFamily: "'Brand Headers', sans-serif",
//                     color: "#3E3E3E",
//                     mb: 2,
//                 }}
//             >
//                 Click the button below to register a complete Sample Collection Kit to
//                 the Texas A&amp;M Health system for research use.
//             </Typography>


//             <Typography
//                 sx={{
//                     fontSize: "26px",
//                     fontWeight: 600,
//                     fontFamily: "'Brand Headers', sans-serif",
//                     color: "#500000",
//                     textAlign: "left",
//                     mb: 2,
//                 }}
//             >
//                 Registered Collection Kits
//             </Typography>


//                     paginationMode="server"
//                     rowCount={totalRowCount}
//                     paginationModel={paginationModel}
//                     onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
//                     pageSizeOptions={[5, 10, 20, 50]}
//                 />
//             </Box>
//         </Box>
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import StyledDataGrid from "../../../components/StyledDataGrid";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState, useCallback } from "react";
import PageHeader from "../../../components/PageHeader";
import WorkspacePage from "../../../components/WorkspacePage";
import { Alert, Chip, Select, MenuItem, Tooltip } from "@mui/material";
import { fetchCollectionKitsPaged, fetchKitTypeOptions } from "../../../utils/api";
import { getStatusChipStyle, BASE_CHIP_SX } from "../../../constants/statusColors";
import { formatLongDateInAppTimeZone, nowIso } from "../../../utils/appDateTime";
import { BIOBANK_SUB_ROUTES } from "../../../constants/routes";

import CurrentDateDisplay from "../../../components/CurrentDate";

const CollectionKit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [newKitPopup, setNewKitPopup] = useState(false);
  const [highlightId, setHighlightId] = useState(null);
  const [kitTypeFilter, setKitTypeFilter] = useState(null); // New: kitType filter state
  const [kitTypeOptions, setKitTypeOptions] = useState([]); // New: kitType options from API

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });

  const todayStr = useMemo(
    () => formatLongDateInAppTimeZone(nowIso()),
    [],
  );

  const handleNewKit = () => {
    navigate(BIOBANK_SUB_ROUTES.COLLECTION_KITS_NEW);
  };

  const columns = [
    {
      field: "kit_number",
      headerName: "Kit Number",
      flex: 0.2,  // 20%
      minWidth: 120
    },
    {
      field: "Status",
      headerName: "Batch Status",
      flex: 0.2,  // 20%
      minWidth: 130,
      renderCell: (params) => {
        const status = params.row.Status || params.row.status || params.value;
        return (
          <Chip
            label={status || "Unknown"}
            size="small"
            sx={{
              ...BASE_CHIP_SX,
              ...getStatusChipStyle(status),
              minWidth: "100px",  // Fixed minimum width for all chips
            }}
          />
        );
      },
    },
    {
      field: "progress",
      headerName: "Kit Usage",
      flex: 0.2,  // 20%
      minWidth: 100,
      renderCell: (params) => {
        const summary = params.row.summary;
        if (!summary) return "N/A";
        const collected = summary.totalCollected;
        const expected = summary.totalExpected;
        return (
          <Typography variant="body2" sx={{ color: "text.primary" }}>
            {collected} / {expected}
          </Typography>
        );
      },
    },
    {
      field: "tubeAvailability",
      headerName: "Tube Availability",
      flex: 0.4,  // 40%
      minWidth: 250,
      renderCell: (params) => {
        const items = params.row.items || [];
        const availableSamples = params.row.availableSamples || [];
        const summary = params.row.summary;

        if (!summary) return "N/A";

        // Get all expected sample types (collected + available)
        const collectedTypes = items.map(item => item.sampleType);
        const availableTypes = availableSamples.map(sample => sample.sampleLetter);
        const allTypes = [...new Set([...collectedTypes, ...availableTypes])].sort();

        return (
          <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", height: "100%" }}>
            {allTypes.map((type) => {
              const isCollected = collectedTypes.includes(type);
              return (
                <Box
                  key={type}
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    backgroundColor: isCollected ? "#e0e0e0" : "#4caf50",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: isCollected ? "#9e9e9e" : "#fff",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    cursor: "default",
                    boxShadow: isCollected ? "none" : "0 1px 3px rgba(0,0,0,0.2)",
                  }}
                >
                  {type}
                </Box>
              );
            })}
          </Box>
        );
      }
    }
  ];

  const loadPagedKits = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchCollectionKitsPaged(
        paginationModel.page,
        paginationModel.pageSize,
        null, // batchId filter
        kitTypeFilter // New: pass kitType filter
      );

      if (data && Array.isArray(data.content)) {
        let formattedRows = data.content
          .map((kitStatus) => {
            // Use backend-provided batchStatus instead of calculating
            const displayStatus = {
              "AVAILABLE": "Available",
              "RESERVED": "Reserved",
              "IN_PROGRESS": "Partial",
              "COMPLETED": "Used"  // Changed from "Completed" to "Used"
            }[kitStatus.batchStatus] || "Unknown";

            return {
              id: kitStatus.kitId,
              kit_number: kitStatus.kitId,
              batchStatus: kitStatus.batchStatus,
              collectionStatus: kitStatus.collectionStatus,
              Status: displayStatus,
              summary: kitStatus.summary,
              items: kitStatus.items || [],  // Store collected samples
              availableSamples: kitStatus.availableSamplesToCollect, // Store for tube availability column
            };
          });

        // Remove frontend sorting - backend now sorts by kitNumber
        // formattedRows.sort(...); // Deleted

        setRows(formattedRows);
        setTotalRowCount(data.totalElements || 0);
      } else {
        console.error("Unexpected API response structure:", data);
        setRows([]);
        setTotalRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching collection kits:", error);
      setRows([]);
      setTotalRowCount(0);
    } finally {
      setLoading(false);
    }
  }, [paginationModel.page, paginationModel.pageSize, kitTypeFilter]); // Add kitTypeFilter dependency

  useEffect(() => {
    loadPagedKits();
  }, [loadPagedKits]);

  // Load kitType options from API
  useEffect(() => {
    const loadKitTypeOptions = async () => {
      try {
        const options = await fetchKitTypeOptions();
        setKitTypeOptions(options);
      } catch (error) {
        console.error("Error loading kit type options:", error);
      }
    };
    loadKitTypeOptions();
  }, []); // Load once on mount

  useEffect(() => {
    let popupTimer;
    let highlightTimer;

    if (location?.state?.complete) {
      setNewKitPopup(true);

      if (location?.state?.kitId) {
        setHighlightId(String(location.state.kitId));
        highlightTimer = setTimeout(() => setHighlightId(null), 10000);
      }

      popupTimer = setTimeout(() => setNewKitPopup(false), 10000);

      if (window?.history?.replaceState) {
        const { pathname, search, hash } = window.location;
        window.history.replaceState({}, "", pathname + search + hash);
      }
    }

    return () => {
      if (popupTimer) clearTimeout(popupTimer);
      if (highlightTimer) clearTimeout(highlightTimer);
    };
  }, [location?.state?.complete, location?.state?.kitId]);

  const getRowClassName = (params) => {
    const rowIdStr = String(params.id ?? "");
    const kitNumberStr = String(params.row?.kit_number ?? "");
    return highlightId &&
      (rowIdStr === highlightId || kitNumberStr === highlightId)
      ? "newly-registered"
      : "";
  };

  return (
    <WorkspacePage>
      {newKitPopup && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "fixed",
            top: 60,
            zIndex: 1,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Alert variant="filled" severity="success" sx={{ maxWidth: 360 }}>
            Collection Kit Registration Complete!
          </Alert>
        </Box>
      )}

      <PageHeader
        title="Collection Kits"
        actions={
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Select
              value={kitTypeFilter || ""}
              onChange={(e) => setKitTypeFilter(e.target.value || null)}
              displayEmpty
              size="small"
              sx={{ minWidth: 150, bgcolor: 'white' }}
              data-tour-id="tour-kit-type-filter"
            >
              <MenuItem value="">All Kit Types</MenuItem>
              {kitTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <Button
              variant="contained"
              onClick={handleNewKit}
              sx={{ fontWeight: 600, height: "40px", px: 3, fontSize: "14px", whiteSpace: "nowrap" }}
              data-tour-id="tour-register-kit"
            >
              Register New Kit
            </Button>
          </Box>
        }
      />

      {/*<Typography*/}
      {/*  sx={{*/}
      {/*    fontSize: "18px",*/}
      {/*    fontWeight: 600,*/}
      {/*    fontFamily: "'Brand Headers', sans-serif",*/}
      {/*    color: "#3E3E3E",*/}
      {/*    mb: 5,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Click the button below to register a complete Sample Collection Kit to*/}
      {/*  the Texas A&amp;M Health system for research use.*/}
      {/*</Typography>*/}




      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          "& .newly-registered": {
            backgroundColor: "rgba(201, 79, 79, 0.15)",
            transition: "background-color 0.3s ease",
          },
          "& .MuiDataGrid-cell": {
            paddingLeft: "12px",
            paddingRight: "12px",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#F5F5F5",
          },
        }}
        data-tour-id="tour-kit-table"
      >
        <StyledDataGrid
          rows={rows}
          columns={columns}
          getRowClassName={getRowClassName}
          loading={loading}
          paginationMode="server"
          rowCount={totalRowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </Box>
    </WorkspacePage>
  );
};

export default CollectionKit;
